import { useEffect } from 'react';
import { GoogleAnalytics } from 'components/GoogleAnalytics';
import { Header, Footer } from './components/layout';
import { Hero, AboutUs, Locations, Services, WhyUs, CTA } from './components/sections';
import { AboutModal, ContactModal, CalculatorModal } from './components/modals';
import { useModal, useHash } from './hooks';

export function MainPage() {
    const aboutModal = useModal();
    const contactModal = useModal();
    const calculatorModal = useModal();
    const { isHash, clearHash } = useHash();

    // Handle hash-based contact popup
    useEffect(() => {
        if (isHash('contact-popup')) {
            contactModal.open();
        }
    }, [isHash, contactModal]);

    // Handle legacy openCalculator event (for backward compatibility)
    useEffect(() => {
        const handleOpenCalculator = () => calculatorModal.open();
        window.addEventListener('openCalculator', handleOpenCalculator);
        return () => window.removeEventListener('openCalculator', handleOpenCalculator);
    }, [calculatorModal]);

    const handleContactClose = () => {
        contactModal.close();
        clearHash();
    };

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <GoogleAnalytics gaCode="G-9K0KHQ2PY0" />

            {/* Header */}
            <Header onCalculatorClick={calculatorModal.open} />

            {/* Main Content */}
            <main className="flex-1">
                {/* Hero Section */}
                <Hero />

                {/* About Us Section */}
                <AboutUs />

                {/* Locations Section */}
                <Locations />

                {/* Services Section */}
                <Services />

                {/* Why Us Section */}
                <WhyUs />

                {/* Call to Action Section */}
                <CTA onContactClick={contactModal.open} />
            </main>

            {/* Footer */}
            <Footer onAboutClick={aboutModal.open} onContactClick={contactModal.open} />

            {/* Modals */}
            <AboutModal isOpen={aboutModal.isOpen} onClose={aboutModal.close} />
            <ContactModal isOpen={contactModal.isOpen} onClose={handleContactClose} />
            <CalculatorModal isOpen={calculatorModal.isOpen} onClose={calculatorModal.close} />
        </div>
    );
}
